/* =============================================================
 * import
 * ========================================================== */
import {gsap} from 'gsap';
import {CustomEase} from "gsap/CustomEase";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {mediaQuery} from "./common";
import {disableScrollAnimation} from "./common";

gsap.registerPlugin(CustomEase, ScrollTrigger, ScrollSmoother);
CustomEase.create("fadeCurtain", ".25, .46, .45, .94");
/*
ScrollTrigger.normalizeScroll({
  allowNestedScroll: true,
  lockAxis : true,
  momentum: self => Math.min(3, self.velocityY / 1000), // dynamically control the duration of the momentum when flick-scrolling
  type: "touch,wheel,pointer", // now the page will be drag-scrollable on desktop because "pointer" is in the list
});
*/

let smoothScrub;
let normalizeScrollFlg;
let effectsFlg;


if (disableScrollAnimation()) {
  smoothScrub = 0;
  normalizeScrollFlg = false;
  effectsFlg = false;
  ScrollTrigger.normalizeScroll(false);
} else {
  smoothScrub = 2.5;
  normalizeScrollFlg = true;
  effectsFlg = true;
}

// ScrollSmootherのオプション
export const ScrollSmootherOpt = { // eslint-disable-line @typescript-eslint/no-unused-vars
  wrapper: '.main',
  content: '.main_container',
  effects: effectsFlg,
  normalizeScroll: normalizeScrollFlg,
  ignoreMobileResize: true,
  smooth: smoothScrub,
  // smoothTouch: 0,
};

export let smoother;


// ScrollSmootherを初期化
if (disableScrollAnimation()) {
  smoother = null;
  const main = document.querySelector('.main');
  main.classList.add('touch_device'); // touch device時に各種アニメーション等々を消すためのクラス（landing時）
} else {
  smoother = ScrollSmoother.create(ScrollSmootherOpt); // eslint-disable-line @typescript-eslint/no-unused-vars
}


/* =============================================================
 * function
 * ========================================================== */

// ScrollSmootherの初期化用関数
export function initParallax() {
  if (!disableScrollAnimation()) {
    ScrollSmoother.create(ScrollSmootherOpt);
  }

  floatingHeader();
  // parallaxScrollEffect();
  imageScrollEffect();
  // negativeScrollEffect();
  kvScrollEffect();
  accessScrollEffect();
  footerScrollEffect();
  menuScrollEffect();
  dishScrollEffect();
  ScrollTrigger.refresh();
}


function floatingHeader() {

  // GSAPのScrollTriggerを使ってスクロールのトリガーを設定する
  const header = document.querySelector('#header');
  const hum = document.querySelector('#hum');

  ScrollTrigger.create({
    start: 130,
    scrub: true,
    onToggle: self => {
      if (self.isActive) {
        header.classList.add('scrolled');
        hum.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
        hum.classList.remove('scrolled');
      }
    },
  });
}



function imageScrollEffect() {
  // Parallax effect 1
  const pax1 = gsap.utils.toArray(".js-pax-outer");
  if (pax1.length > 0) {
    pax1.forEach(elm => {
      if (window.getComputedStyle(elm).getPropertyValue('display') === 'inline') {
        elm.style.display = 'inline-block';
      }
      const elmOuterHeight = elm.clientHeight;
      const elmInner = elm.querySelector(".js-pax-inner");
      const elmInnerHeight = elmInner.clientHeight;
      const elmDiffHeight = elmInnerHeight - elmOuterHeight;
      const distance = Number(elm.getAttribute('data-vs-pax-size')) || 0;    // SP時の動きの大きさ
      let elmDiffOuter = 0;
      let elmDiffInner = 0;

      if (distance !== 0) {
        elmDiffOuter = distance;
        elmDiffInner = elmDiffHeight;
      } else {
        elmDiffOuter = -elmDiffHeight;
        elmDiffInner = elmDiffHeight;
      }

      gsap.from(elm, {
        y: elmDiffOuter,
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom', // top-=100 bottom
          end: 'bottom top',
          scrub: 2,
          invalidateOnRefresh: true, // update on resize
        },
      });

      gsap.from(elmInner, {
        y: elmDiffInner,
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom', // top-=100 bottom
          end: 'bottom top',
          scrub: 1,
          invalidateOnRefresh: true, // update on resize
        },
      });
    });
  }
}


/*
function parallaxScrollEffect() {
  // Parallax effect 2
  const pax2 = gsap.utils.toArray(".vs-pax");
  if (pax2.length > 0) {
    pax2.forEach(elm => {
      let y = 0;
      let x = 0;
      let distance = elm.getAttribute('data-vs-pax-size') || -50;    // SP時の動きの大きさ
      const distanceSp = elm.getAttribute('data-vs-pax-size-sp') || distance;    // 動きの大きさ
      let direction = elm.getAttribute('data-vs-pax-dir') || 'y'; // 動きの方向（X：横、Y：縦）
      const directionSp = elm.getAttribute('data-vs-pax-dir-sp') || direction; // 動きの方向（X：横、Y：縦）
      const scrub = elm.getAttribute('data-vs-pax-scrub') || 0.5;   // 動きの粒度（アニメーションの大きさ、慣性の大きさ）

      if (window.getComputedStyle(elm).getPropertyValue('display') === 'inline') {
        elm.style.display = 'inline-block';
      }

      if (mediaQuery() === 'sp') {

        if (directionSp === 'none') {
          return;
        }

        distance = distanceSp;
        direction = directionSp;
      }

      if (direction === 'y') {
        y = distance;
      } else {
        x = distance;
      }

      gsap.set(elm, {
        x: -x,
        y: -y,
      });

      gsap.to(elm, {
        x: x,
        y: y,
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom', // top-=100 bottom
          end: 'bottom top',
          scrub: scrub,
          invalidateOnRefresh: true, // update on resize
          // scroller: scrollContainer,
          // once: true,
          // markers: true,
          // onEnter: () => elm.classList.add("js-vs-enter"),
        },
      });
    });
  }
}
*/


function menuScrollEffect() {
  const bgOpening = document.querySelector('.bg_opening');
  const header = document.querySelector('#header');
  const trigger = document.querySelector('#menu');
  const triggerBefore = document.querySelector('#chef');
  const changer = document.querySelector('.top_menu_bg');

  changer.style.zIndex = '-2';
  /*
  // 処理を重さを考慮しCSS管理に移行
  if (changer != null) {
    gsap.set(changer, {
      // autoAlpha: 0, //（初回読み込み時にカクッとなる現象を回避する目的でautoAlphaを辞め、以下の方法に移行）
      opacity: 0.001, // 0にすると読み込みが開始されないので、要素自体を薄くし、裏側で読み込む
      zIndex: -2, // -1以上にするとうっすら見えてしまうので、-2以下に下げることで裏に隠す
    });
  }
  */

  if (trigger != null) {

    changer.style.display = 'block'; // TOPページでのみ必要

    const enterEffect = () => {
      header.classList.add('negative');
      trigger.classList.add('active');
      triggerBefore.classList.add('active');
      changer.style.zIndex = '-1';

      if (disableScrollAnimation()) {
        bgOpening.style.opacity = '0'; // 戻す必要はないのでこのまま消す
      }

      changer.classList.add('active');
    };

    const leaveEffect = () => {
      header.classList.remove('negative');
      trigger.classList.remove('active');
      triggerBefore.classList.remove('active');

      changer.classList.remove('active');
    };

    ScrollTrigger.create({
      trigger: trigger,
      start: "top center",
      end: "bottom top",
      onEnter: enterEffect,
      onEnterBack: enterEffect,
      onLeave: leaveEffect,
      onLeaveBack: leaveEffect,
      scrub: true,
    });

    const elmInner = document.querySelector(".top_menu_bg_img");

    if (mediaQuery() !== 'sp') {

      let elmOuterHeight = changer.clientHeight;
      let elmInnerHeight = elmInner.clientHeight;

      gsap.set(elmInner, {
        marginTop: 0,
        top: 0,
      });

      gsap.to(elmInner, {
        y: () => -(elmInnerHeight - elmOuterHeight),
        scrollTrigger: {
          trigger: trigger,
          start: 'top bottom', // top-=100 bottom
          end: 'bottom top',
          scrub: 2,
          invalidateOnRefresh: true, // update on resize
          onRefresh: () => {
            elmOuterHeight = changer.clientHeight;
            elmInnerHeight = elmInner.clientHeight;
          },
        },
      });

    } else {

      let elmOuterWidth = changer.clientWidth;
      let elmInnerWidth = elmInner.clientWidth;

      gsap.set(elmInner, {
        marginTop: 0,
        top: 0,
      });

      gsap.to(elmInner, {
        x: () => -(elmInnerWidth - elmOuterWidth),
        scrollTrigger: {
          trigger: trigger,
          start: 'top bottom', // top-=100 bottom
          end: 'bottom top',
          scrub: 2,
          invalidateOnRefresh: true, // update on resize
          onRefresh: () => {
            elmOuterWidth = changer.clientWidth;
            elmInnerWidth = elmInner.clientWidth;
          },
        },
      });

    }

  } else {

    changer.style.display = 'none'; // TOPページでのみ必要

  }
}


function dishScrollEffect() {
  // Pinning and horizontal scrolling
  const dishSection = document.querySelector("#dish");
  const pinSection = dishSection;

  if (dishSection != null && !disableScrollAnimation()) {

    const pinWrap = dishSection.querySelector(".js-scroll-pin-wrap");
    const pinInner = dishSection.querySelector(".js-scroll-pin");
    let pinInnerWidth = pinInner.offsetWidth;
    let pinWrapWidth = pinWrap.clientWidth;

    gsap.set(pinSection, {
      height: () => pinInnerWidth, // 横スクロールコンテンツ分の高さを予め確保する
      onRefresh: () => {
        pinInnerWidth = pinInner.offsetWidth;
      },
    });

    gsap.to(pinInner, {
      x: () => -(pinInnerWidth - pinWrapWidth),  // 横スクロールの長さを設定
      ease: "none",
      scrollTrigger: {
        trigger: pinWrap,
        scrub: 1,
        pin: true,
        anticipatePin: 1,
        start: "top top",
        end: () => `+=${pinInnerWidth - pinWrapWidth}`,    // 横スクロールの長さを設定
        invalidateOnRefresh: true, // update on resize
        onRefresh: () => {
          pinInnerWidth = pinInner.offsetWidth;
          pinWrapWidth = pinWrap.clientWidth;
        },
      },
    });

    const nexSection = document.querySelector(".top_information");
    let windowHeight = window.innerHeight;
    let pinInnerHeight = pinInner.clientHeight;
    let calcHeight = (windowHeight - pinInnerHeight) * 0.5 + (pinInner.clientHeight * 0.5);
    gsap.to(pinInner, {
      autoAlpha: 0,
      ease: "none",
      scrollTrigger: {
        trigger: nexSection,
        scrub: 1,
        start: "top bottom",
        // end: "top bottom-=646",
        end: () => `-=${calcHeight}`,
        invalidateOnRefresh: true, // update on resize
        onRefresh: () => {
          windowHeight = window.innerHeight;
          pinInnerHeight = pinInner.clientHeight;
          calcHeight = (windowHeight - pinInnerHeight) * 0.5 + (pinInner.clientHeight * 0.5);
        },
      },
    });

  }

}


function accessScrollEffect() {
  // Parallax access horizontal effect
  const accSection = document.querySelector(".js-scroll-hoz-wrapper");
  if (accSection != null) {
    const accTarget = accSection.querySelector(".js-scroll-hoz-target");
    const accInner = accSection.querySelector(".js-scroll-hoz-inner");

    // const accOuterWidth = accTarget.clientWidth;
    // const accInnerWidth = accInner.clientWidth;
    // const accDiffWidth = accInnerWidth - accOuterWidth;
    const accDiffWidth = 200;

    gsap.from(accTarget, {
      x: accDiffWidth,
      scrollTrigger: {
        trigger: accTarget,
        start: 'top bottom', // top-=100 bottom
        end: 'top top',
        scrub: 1.5,
        invalidateOnRefresh: true, // update on resize
      },
    });

    gsap.from(accInner, {
      x: -accDiffWidth,
      scrollTrigger: {
        trigger: accTarget,
        start: 'top bottom', // top-=100 bottom
        end: 'top top',
        scrub: 1.5,
        invalidateOnRefresh: true, // update on resize
      },
    });

  }
}


function footerScrollEffect() {
  // Footer Effect
  const footerSection = document.querySelector(".footer");

  if (footerSection != null) {

    const pinWrap = footerSection.querySelector(".js-scroll-pin-wrap");
    const bgWrapper = footerSection.querySelector(".footer_bg");
    const bgMaskImage = footerSection.querySelector(".footer_bg_mask");
    const bgImage = footerSection.querySelector(".footer_bg_img");
    const hum = document.querySelector(".hum");
    const headerReserve = document.querySelector("#header > .header_reserve");
    const headerBottom = document.querySelector("#header > .header_bottom");
    let windowHeight = window.innerHeight;
    let bgHeight = bgWrapper.clientHeight;
    let bgImageHeight = bgImage.clientHeight;
    let startPoint;

    const enterEffect = () => {
      footerSection.classList.add('active');
      headerReserve.classList.add('negative');
      headerBottom.classList.add('negative');

      if (mediaQuery() === 'sp' || bgHeight > windowHeight) {
        hum.classList.add('negative');
      }
    };

    const leaveEffect = () => {
      footerSection.classList.remove('active');
      headerReserve.classList.remove('negative');
      headerBottom.classList.remove('negative');

      if (mediaQuery() === 'sp' || bgHeight > windowHeight) {
        hum.classList.remove('negative');
      }
    };

    if (disableScrollAnimation()) {
      startPoint = 'bottom bottom+=500';
    } else {
      startPoint = 'top top';
    }

    ScrollTrigger.create({
      trigger: footerSection,
      start: startPoint,
      end: 'bottom bottom',
      scrub: 2,
      invalidateOnRefresh: true, // update on resize
      ignoreMobileResize: true,
      // markers: true,
      onEnter: enterEffect,
      onLeaveBack: leaveEffect,
      // onEnterBack: enterEffect,
      // onLeave: leaveEffect,
      onRefresh: () => {
        windowHeight = window.innerHeight;
        bgHeight = bgWrapper.clientHeight;
      },
    });

    if (!disableScrollAnimation()) {
      const footerHeight = 1080;
      const triggerObj = {
        trigger: pinWrap,
        scrub: true,
        pin: true,
        anticipatePin: 1,
        start: "top top",
        end: () => "bottom bottom", // Pinの終了位置をトリガー要素の高さに合わせる
        invalidateOnRefresh: true, // update on resize
        ignoreMobileResize: true,
      };

      gsap.fromTo(bgWrapper, {
        opacity: 0,
        y: () => windowHeight * .4,
      },{
        opacity: 1,
        y: 0,
        ease: "none",
        scrollTrigger: triggerObj,
      });

      gsap.fromTo(bgImage, {
        y: () => -(bgImageHeight - footerHeight),
      }, {
        y: () => 0,
        ease: "none",
        scrollTrigger: {
          trigger: pinWrap,
          scrub: true,
          start: "top top",
          end: () => "bottom bottom", // Pinの終了位置をトリガー要素の高さに合わせる
          invalidateOnRefresh: true, // update on resize
          onRefresh: () => {
            bgImageHeight = bgImage.clientHeight;

            if (bgImageHeight > windowHeight) {
              gsap.set(bgMaskImage, {
                y: 0,
              });
            } else {
              gsap.set(bgMaskImage, {
                y: () => -(bgImageHeight - windowHeight),
              });
            }
          },
        },
      });
    }

  }

}


function kvScrollEffect() {
  // TOP KV scroll effect オープニング非表示時 or 下層からの遷移時のみ有効
  const kvSection = document.querySelector(".kv");

  if (kvSection != null) {
    const header = document.querySelector('.header');
    const enterEffect = () => {
      header.classList.add('negative');
    };

    const leaveEffect = () => {
      header.classList.remove('negative');
    };

    ScrollTrigger.create({
      trigger: kvSection,
      start: 'top bottom', // top-=100 bottom
      end: 'bottom center',
      onEnter: enterEffect,
      onEnterBack: enterEffect,
      onLeave: leaveEffect,
      onLeaveBack: leaveEffect,
      scrub: true,
    });
  }
}


/*
function negativeScrollEffect() {
  // Control negative / positive element
  // デザインの仕様上、不要に。
  const negative = gsap.utils.toArray(".negative");
  if (negative.length > 0) {
    negative.forEach(elm => {
      const elmHeight = elm.clientHeight;
      const floatingHeight = window.innerHeight; // 画面高さ100%の要素ではない場合は取得後設定する
      let targets = ['.negative_header.negative_header_left', '.negative_header.negative_header_right'];
      if (elm.classList.contains('footer')) {
        targets = ['.negative_header.negative_header_right'];
      }

      const scrollOptions = {
        trigger: elm,
        start: 'top bottom', // top-=100 bottom
        end: 'bottom top',
        scrub: .01,
        invalidateOnRefresh: true, // update on resize
        // once: true,
        // onEnter: () => elm.classList.add("js-vs-enter"),
        // markers: {startColor: "green", endColor: "red", fontSize: "12px"},
      };
      gsap.set(targets, {
        webkitClipPath: 'inset(100% 0% 0%)',
        clipPath: 'inset(100% 0% 0%)',
      });
      gsap.fromTo(targets, {
        webkitClipPath: () => 'inset(' + floatingHeight + 'px 0% ' + -elmHeight + 'px)',
        clipPath: () => 'inset(' + floatingHeight + 'px 0% ' + -elmHeight + 'px)',
      }, {
        webkitClipPath: () => 'inset(' + -elmHeight + 'px 0% ' + floatingHeight + 'px)',
        clipPath: () => 'inset(' + -elmHeight + 'px 0% ' + floatingHeight + 'px)',
        ease: 'linear',
        duration: .01,
        scrollTrigger: scrollOptions,
      });
    });
  }

}
*/
